import React from 'react';
import { RELIGIONS, CULTURES, SUBCOMMUNITIES, LANGUAGES } from "../../../constants/formData";

const ReligiousBackgroundSection = ({ setEditingFields, isEditing, getValue, onDataChange, editingFields, onEditClick, onSaveClick, onCancelClick }) => {
  return (
    <div className="row py-3 border-top">
      <div className="col-md-6 pe-md-4">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mini-section-title mb-2">Culture & Religion</h6>
          {isEditing && editingFields === "religious" ? (
            <span className="d-flex gap-2">
              <a onClick={onSaveClick} className="mini-edit-link text-primary cursor-pointer">
                Save
              </a>
              <a onClick={onCancelClick} className="mini-edit-link text-primary cursor-pointer">
                Cancel
              </a>
            </span>
          ) : (
            <a onClick={() => { onEditClick(); setEditingFields("religious") }} className="mini-edit-link text-primary cursor-pointer">
              Edit
            </a>
          )}
        </div>

        <table className="table table-borderless table-sm mini-data mb-0">
          <tbody>
            <tr>
              <td>Religion:</td>
              <td>{isEditing && editingFields === "religious" ? (
                <select 
                  value={getValue('religion') || ''} 
                  onChange={(e) => onDataChange('religion', e.target.value)}
                  className="form-select form-select-sm d-inline-block w-75"
                >
                  <option value="">Select</option>
                  {RELIGIONS.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              ) : (
                getValue('religion')
              )}</td>
            </tr>
            <tr>
              <td>Culture:</td>
              <td>{isEditing && editingFields === "religious" ? (
                <select 
                  value={getValue('culture') || ''} 
                  onChange={(e) => onDataChange('culture', e.target.value)}
                  className="form-select form-select-sm d-inline-block w-75"
                >
                  <option value="">Select</option>
                  {CULTURES.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              ) : (
                getValue('culture')
              )}</td>
            </tr>
            <tr>
              <td>Language:</td>
              <td>{isEditing && editingFields === "religious" ? (
                <select 
                  value={getValue('mother_tongue') || ''} 
                  onChange={(e) => onDataChange('mother_tongue', e.target.value)}
                  className="form-select form-select-sm d-inline-block w-75"
                >
                  <option value="">Select</option>
                  {LANGUAGES.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              ) : (
                getValue('mother_tongue') || '------'
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReligiousBackgroundSection;